module.exports = __webpack_public_path__ + "static/img/power-shard_256.ea05afe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/power-shard_256.png
// module id = cgg9
// module chunks = 0